import { render } from "./single-edit.vue?vue&type=template&id=52c1673a&scoped=true"
import script from "./single-edit.vue?vue&type=script&lang=js"
export * from "./single-edit.vue?vue&type=script&lang=js"

import "./single-edit.vue?vue&type=style&index=0&id=52c1673a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c1673a"],['__file',"src/views/room/roomCount/single-edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52c1673a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52c1673a', __exports__)) {
    console.log('reload')
    api.reload('52c1673a', __exports__)
  }
  
  module.hot.accept("./single-edit.vue?vue&type=template&id=52c1673a&scoped=true", () => {
    console.log('re-render')
    api.rerender('52c1673a', render)
  })

}


export default __exports__